<div class="prefooter-row" [class]="orientation" #prefooter>
  <!-- Image Section -->
  <div
    class="prefooter-image-col"
    [class.static-image]="staticImage"
    [class.image-background]="imageBackground"
    [class.no-badge]="!showBadge"
  >
    <div
      class="img"
      [ngClass]="{ 'img--no-play-button': !showPlayButton }"
      [style.backgroundColor]="imageBackground || 'transparent'"
    >
      <hdi-modal-function
        *ngIf="showPlayButton; else noPlayButton"
        [type]="ModalFunctionType.VIDEO"
        [imageSrc]="imageSrc"
        [imageAlt]="imageAlt"
        [imageTitle]="imageTitle"
        [videoTitle]="videoTitle"
        [videoSrc]="videoSrc"
        [videoId]="videoId"
        [thumbnailSrc]="thumbnailSrc"
        [showIcon]="showPlayButton"
      ></hdi-modal-function>
      <ng-template #noPlayButton>
        <hdi-image
          *ngIf="imageSrc"
          [src]="imageSrc"
          [alt]="imageAlt"
          [title]="imageTitle"
        ></hdi-image>
      </ng-template>
      <div
        *ngIf="showBadge"
        class="prefooter-image-col-badge"
        [class]="orientation"
      >
        <hdi-image *ngIf="badgeContent === MediaType.IMAGE" [src]="badgeSrc" />
        <hdi-icon
          *ngIf="badgeContent === MediaType.ICON"
          [iconName]="badgeIcon"
          [size]="this.screenWidth > 1200 ? Sizes.XXLARGE : Sizes.XLARGE"
          [color]="Colors.WHITE"
        />
      </div>
    </div>
  </div>

  <!-- Text Section -->
  <div class="prefooter-text-col">
    <h2 *ngIf="headline">{{ headline }}</h2>
    <div *ngIf="innerHTMLText" [innerHTML]="innerHTMLText"></div>
    <div
      *ngIf="clickableCategory === 'button' || clickableCategory === 'link'"
      class="prefooter-text-col-buttons"
      [class]="buttonsFlex"
    >
      <!-- Clickable Button -->
      <hdi-button
        *ngIf="clickableCategory === 'button'"
        [type]="buttonType"
        [label]="clickableText | capitalize"
        [iconName]="clickableIcon"
        [isWithoutIcon]="true"
        [title]="clickableTitle"
        [disabled]="!isActive"
        (clickEvent)="handleClick($event)"
      ></hdi-button>
      <hdi-link
        *ngIf="clickableCategory === 'link'"
        [type]="linkType"
        [href]="clickableHref"
        [title]="clickableTitle"
        [disabled]="!isActive"
        [hrefType]="
          hrefType === HrefType.ANGULAR_ROUTE
            ? HrefType.ANGULAR_ROUTE
            : hrefType === HrefType.OPEN_MODAL_VIDEO
              ? HrefType.OPEN_MODAL_VIDEO
              : HrefType.EXTERNAL
        "
        [video]="clickableVideo"
        [label]="clickableText | capitalize"
      ></hdi-link>

      <!-- Optional Link -->
      <hdi-link
        *ngIf="optionalLinkText && optionalLinkHref"
        [type]="optionalLinkType"
        [href]="optionalLinkHref"
        [label]="optionalLinkText | capitalize"
        [video]="optionalLinkVideo"
        [title]="optionalLinkTitle"
        [hrefType]="
          optionalHrefType === HrefType.ANGULAR_ROUTE
            ? HrefType.ANGULAR_ROUTE
            : optionalHrefType === HrefType.OPEN_MODAL_VIDEO
              ? HrefType.OPEN_MODAL_VIDEO
              : HrefType.EXTERNAL
        "
      ></hdi-link>
    </div>
  </div>
</div>
